import { useCallback, useState } from 'react';
export function useClientSelection() {
    const [selectedIds, setSelectedIds] = useState(()=>new Set());
    const getSelectedIds = useCallback(()=>[
            ...selectedIds
        ].map(String), [
        selectedIds
    ]);
    const clearSelection = useCallback(()=>setSelectedIds(new Set()), []);
    return {
        selectedIds,
        numSelected: selectedIds.size,
        onSelectionChange: setSelectedIds,
        getSelectedIds,
        clearSelection
    };
}
